import * as yup from 'yup'
import {
  getNameSchema,
  getEmailSchema,
  getPhoneSchema,
  emailErrorMsg,
  emailDomainErrorMsg,
  phoneNumberErrorMsg,
} from 'src/deps'
import { emailValidation } from 'src/utils'
import { validateEmailDomain } from '../../CommonFormForCS/validationSchema'
import { cartContainer } from 'src/models'

export const isValidNonSequentialPhoneNumber = phone => {
  if (!phone || !phone.trim()) return false
  if (phone.includes(' ') || phone.includes('$')) return false

  const cleanPhone = phone.replace(/[^\d]/g, '')
  const tenDigitPattern = /^[0-9]{10}$/
  const allSameDigitPattern = /^(\d)\1{9}$/
  const consecutiveDigitPattern = /^(\d)\1{6,}/
  const sequentialPatterns = [
    /^6789012345$/,
    /^1234567890$/,
    /^9876543210$/,
    /^0123456789$/,
    /^0987654321$/,
    /^2354656879$/,
    /^3546768878$/,
    /^(\d)(\d)\1\2\1\2\1\2\1\2$/,
  ]

  if (!tenDigitPattern.test(cleanPhone)) return false
  if (!/^[6-9]/.test(cleanPhone)) return false
  if (allSameDigitPattern.test(cleanPhone)) return false
  if (consecutiveDigitPattern.test(cleanPhone)) return false
  if (sequentialPatterns.some(pattern => pattern.test(cleanPhone))) return false

  return true
}

export const getDefaultSchema = (
  isStateFieldDropDown,
  isGuestOrUser,
  countryValue
) => {
  let schemaData = Object.assign(
    {},
    getNameSchema(),
    getNameSchema({ isLastName: true, inputName: 'lastName' }),
    getImportedDevicePhoneSchema({ inputName: 'phone' }),
    getImportedDeviceEmailSchema({ inputName: 'userEmailAddress' })
  )

  return yup.object(schemaData)
}

export function getImportedDeviceEmailSchema(props) {
  const emailSchema = {}

  const {
    invalidErrorText = emailErrorMsg,
    invalidDomainErrorText = emailDomainErrorMsg,
    inputName = 'userEmailAddress',
  } = props || {}

  emailSchema[inputName] = yup
    .string()
    .transform((value, originalValue) => {
      if (!originalValue) return originalValue
      return originalValue.trim()
    })
    .test('conditional-required-email', function (value) {
      const selectedContactMethod =
        cartContainer?.selectedPreferContactMethod || 'SMS'

      if (selectedContactMethod === 'Email') {
        if (!value || value.trim() === '') {
          return this.createError({
            message: invalidErrorText,
            path: this.path,
          })
        }
        if (value.includes(' ')) {
          return this.createError({
            message: invalidErrorText,
            path: this.path,
          })
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(value)) {
          return this.createError({
            message: invalidErrorText,
            path: this.path,
          })
        }
      }

      return true
    })

  return emailSchema
}

export function getImportedDevicePhoneSchema(props) {
  const phoneSchema = {}

  const { invalidErrorText = phoneNumberErrorMsg, inputName = 'phone' } =
    props || {}

  phoneSchema[inputName] = yup
    .string()
    .nullable()
    .test('conditional-phone-validation', invalidErrorText, function (value) {
      const selectedContactMethod =
        cartContainer?.selectedPreferContactMethod || 'SMS'
      const cleanPhone = value ? value.replace(/[^\d]/g, '') : ''
      if (
        selectedContactMethod === 'SMS' ||
        selectedContactMethod === 'WhatsApp'
      ) {
        if (!isValidNonSequentialPhoneNumber(cleanPhone)) {
          return this.createError({
            message: invalidErrorText,
            path: this.path,
          })
        }
      }
      return true
    })

  return phoneSchema
}
